import { userConstants } from '../actions/userTypes';

export const initialState = {
    isLoggedIn: false,
    isLoggingIn: false,
    loginError: '',
    isRegistered: false,
    isActive: true,
    error: '',
    showError: false,
    showNullError: false,
    msg: '',
    token: '',
    updated: false,
    user: {
        acc_type: '',
        address: '',
        address_2: '',
        company: '',
        email: '',
        isActive: true,
        name: '',
        phone: '',
        role: '',
        title: '',
        _id: '',
        stripeCustomer: {},
        baseSubscription: {}
    },
    isAuthenticated: false, // Added isAuthenticated flag
    refreshKey: 0
};  

const reducers = (state = initialState, action) => {
    switch (action.type) {
        case userConstants.LOGIN_START: {
            return {
                ...state,
                isLoggingIn: true
            };
        }
        case userConstants.LOGIN_SUCCESS: {
            const { user, token, extraFlag } = action.payload;
          
            // Determine final value:
            // priority: if extraFlag exists, use it
            // otherwise rely on user.additional_questions_answered
            const answered =
              typeof extraFlag !== 'undefined'
                ? extraFlag
                : (typeof user.additional_questions_answered === 'undefined'
                    ? true
                    : user.additional_questions_answered);
          
            return {
              ...state,
              user,
              token,
              isLoggingIn: false,
              isLoggedIn: true,
              isAuthenticated: true,
              additional_questions_answered: answered, 
              trialed_before: user.trialed_before || false,
              trial_start: user.trial_start || null,
              trial_end: user.trial_end || null,
              trial_over: user.trial_over || false,
            };
          }
          
        case userConstants.STAY_LOGGED_IN: {
            return {
                ...state,
                user: action.payload.user,
                isLoggingIn: false,
                isLoggedIn: true,
                token: action.payload.token,
                isAuthenticated: true 
            };
        }
        case userConstants.LOGIN_FAIL: {
            return {
                ...state,
                isLoggingIn: false,
                loginError: action.payload
            };
        }
        case userConstants.UPDATE_TOKEN: {
            return {
                ...state,
                token: action.payload.token
            };
        }
        case userConstants.LOGOUT_USER: {
            localStorage.removeItem('token');
            return {
                ...state,
                isLoggedIn: false,
                token: '',
                isAuthenticated: false // User is not authenticated after logout
            };
        }
        case userConstants.REGISTER_SUCCESS: {
            return {
                ...state,
                isLoggingIn: false,
                isLoggedIn: false,
                isRegistered: true,
                additional_questions_answered: true,
                token: action.payload
            };
        }
        case userConstants.FORGOT_PASSWORD_SUCCESS: {
            return {
                ...state,
                msg: action.payload,
                showError: false,
                showNullError: false,
            };
        }
        case userConstants.FORGOT_PASSWORD_FAILURE: {
            return {
                ...state,
                error: action.payload,
                showError: true,
            };
        }
        case userConstants.RESET_PASSWORD_START: {
            return {
                ...state,
                updated: false
            };
        }
        case userConstants.RESET_PASSWORD_FAILURE: {
            return {
                ...state,
                error: action.payload
            };
        }
        case userConstants.UPDATE_PASSWORD_SUCCESS: {
            return {
                ...state,
                updated: true,
                error: false
            };
        }
        case userConstants.UPDATE_PASSWORD_FAILURE: {
            return {
                ...state,
                error: action.payload
            };
        }
        case userConstants.SET_STRIPE_CUSTOMER:  // New action
            return {
                ...state,
                user: {
                    ...state.user,
                    stripeCustomer: action.payload
                }
            };
        case userConstants.SET_STRIPE_SUBSCRIPTION:  // New action
            return {
                ...state,
                user: {
                    ...state.user,
                    baseSubscription: action.payload
                }
            };
        default: {
            return state;
        }
    }
};

export default reducers;
